const AUTH_TOKEN_KEY = 'kwello_auth_token';

export const setAuthToken = (token: string) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const clearAuthToken = () => {
  return localStorage.removeItem(AUTH_TOKEN_KEY);
};
